import axiosInst from "../../Config";

export const LoginApi = async (credential) =>
  await axiosInst.post(`/vozoportal/login`, credential);
